// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-x.js';

import { paths } from '../generated/circle-x';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-x', Original, paths);
